module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/CMD-b1b75e528c2bc86f239f63db0d273b31.svg";